import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
const { Option } = Select;

const InvoiceSubscriptionTableFilter = (props) => {
  const [form] = Form.useForm();
  const [productTypeSelect, setProductTypeSelect] = useState({
    data: [],
    loading: true,
  });
  const [invoiceSubscriptionSelect, setInvoiceSubscriptionSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    RequestHandler.get(`/Invoice/GetProductTypes`, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status == 200) {
        setProductTypeSelect({
          data: response.data,
          loading: false,
        });
      }
    });
  }, []);

  const onInvoiceSubscriptionSearch = (value) => {
    if (value.length >= 2) {
      setInvoiceSubscriptionSelect({
        ...invoiceSubscriptionSelect,
        loading: true,
      });
      RequestHandler.get(
        `/InvoiceSubscription?$select=id,name&$filter=${odata.contains(
          "name",
          value
        )}`
      ).then((res) => {
        if (res.value) {
          setInvoiceSubscriptionSelect({ data: res.value, loading: false });
        }
      });
    } else {
      setInvoiceSubscriptionSelect({ ...invoiceSubscriptionSelect, data: [] });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.invoiceSubscriptionId) {
        conditions.push(`id eq ${values.invoiceSubscriptionId}`);
      }

      if (values.productType) {
        conditions.push(`productTypeId eq ${values.productType}`);
      }

      if (values.product) {
        conditions.push(`Contains(product,'${values.product}')`);
      }

      if (values.subscriberNo) {
        conditions.push(`Contains(subscriberNo,'${values.subscriberNo}')`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();
    setInvoiceSubscriptionSelect({ data: [] });

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <>
      <Row id="filterArea" style={{ ...props.style }}>
        <Col span={24}>
          <Collapse>
            <Collapse.Panel header="Filtreleme için tıklayınız.">
              <Form
                name="filter"
                form={form}
                initialValues={{
                  remember: true,
                }}
                layout="vertical"
                onFinish={onFinish}
              >
                <Row style={{ flexDirection: "row" }}>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item
                      name="invoiceSubscriptionId"
                      label="Abonelik Adı :"
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        loading={invoiceSubscriptionSelect.loading}
                        onSearch={onInvoiceSubscriptionSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                      >
                        {invoiceSubscriptionSelect.data.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="productType" label="Kurum Tipi :">
                      <Select
                        name="productTypes"
                        style={{ width: "100%" }}
                        loading={false}
                        placeholder="Kurum Tipi"
                      >
                        {productTypeSelect.data.map((item, index) => (
                          <Option key={item.id} value={index}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="product" label="Kurum Adı :">
                      <Input placeholder="Kurum Adı" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="subscriberNo" label="Abone No :">
                      <Input placeholder="Abone No" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ flexDirection: "row" }}>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Button
                      danger
                      size="small"
                      icon={<CloseOutlined />}
                      onClick={() => clearFilter()}
                    >
                      Sıfırla
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      icon={<SearchOutlined />}
                      style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                      htmlType="submit"
                    >
                      Filtrele
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
    </>
  );
};
export default InvoiceSubscriptionTableFilter;
